import React from 'react';
import MeuPedido from '../../Meu_Pedido/Meu_Pedido';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';

function MeuPedidoVisualizar(props) {
  const pedidoEfetuado = props?.props;

  return (
    <>
        <NavBarTop />
        <br />
        <MeuPedido props={pedidoEfetuado} />
        <br />
        <Rodape />
    </>
  )
}

export default MeuPedidoVisualizar;